package com.patronat.top.client.presentation.map

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.patronat.top.client.platform.ClientBackHandler
import org.koin.compose.koinInject

@Composable
fun ClientMapRoute(
    onVenueDetailsRequested: (String) -> Unit
) {
    val viewModel: ClientMapViewModel = koinInject()
    val state by viewModel.viewState.collectAsState()

    ClientBackHandler(
        enabled = state.isListExpanded || state.selectedVenueId != null,
        onBack = {
            when {
                state.isListExpanded -> viewModel.onEvent(ClientMapEvent.OnToggleListClicked)
                state.selectedVenueId != null -> viewModel.onEvent(ClientMapEvent.OnMapClicked)
            }
        }
    )

    ClientMapScreen(
        state = state,
        onEvent = viewModel::onEvent,
        onVenueDetailsRequested = onVenueDetailsRequested
    )
}
